<template>
  <div class="wx-qrcode page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="box-item"
            placeholder="场景值"
            style="width: 100%"
            clearable
            v-model="sceneStr"
          ></el-input>
        </div>
        <el-input
          class="hidden-xs-only box-item"
          placeholder="场景值"
          style="width: 150px"
          clearable
          v-model="sceneStr"
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('wx:wxqrcode:save')"
          class="search-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('wx:wxqrcode:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              类型
            </vs-th>
            <vs-th>
              场景ID
            </vs-th>
            <vs-th>
              场景
            </vs-th>
            <vs-th>
              二维码图片
            </vs-th>
            <vs-th>
              解析后的地址
            </vs-th>
            <vs-th>
              失效时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.isTemp?'临时':'永久'}}
              </vs-td>
              <vs-td>
                {{tr.sceneId}}
              </vs-td>
              <vs-td>
                {{tr.sceneStr}}
              </vs-td>
              <vs-td
                style="max-width: 180px"
              >
                <a
                  class="rap-normal"
                  :href="'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket='+tr.ticket" >{{tr.ticket}}</a>
              </vs-td>
              <vs-td>
                <a
                  :href="tr.url"
                  target="_blank"
                >{{tr.url}}</a>
              </vs-td>
              <vs-td>
                {{parseTime(tr.expireTime)}}
              </vs-td>
              <vs-td>
                <el-button
                  v-if="isAuth('wx:wxqrcode:delete')"
                  type="text"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-qrcode-dialog
      :dialog-show="addDialogShow"
      @close="closeDialog"
      @add-success="editSuccess"
    ></add-qrcode-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import addQrcodeDialog from '@/components/wx/qr-code/addQrcodeDialog'
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteParamsQrcode} from "../../../api/wx/wx-qrcode";
export default {
  name: "index",
  components: {
    addQrcodeDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      sceneStr: '',
      selected: [],
      addDialogShow: false,
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    beforeInit(){
      this.url = '/wx/manage/wxQrCode/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
        'sceneStr': this.sceneStr,
      }
      return true;
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteParamsQrcode(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    closeDialog(){
      this.addDialogShow = false;
    },
    editSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    }
  },
}
</script>

<style lang="scss" scoped>
.wx-qrcode {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .content-header {
    padding-top: 20px;
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }

  .content-header {
    padding-bottom: 10px !important;
  }
}
</style>
